import seoData from "./routeSeo.json";
import { Operations } from "../../MathFactsGenerator/Constants.ts";

export interface FaqEntry {
    q: string;
    a: string;
}

export interface RouteSeo {
    slug: string;
    legacyPaths?: string[];
    operation?: Operations;
    wordProblems?: boolean;
    title: string;
    description: string;
    h1?: string;
    intro?: string[];
    faq?: FaqEntry[];
}

export const SITE_NAME: string = seoData.siteName;
export const SITE_ORIGIN: string = seoData.origin;
export const DEFAULT_IMAGE: string = seoData.defaultImage;

export const Routes: RouteSeo[] = seoData.routes as RouteSeo[];

export function findBySlug(slug: string): RouteSeo | undefined {
    return Routes.find((route) => route.slug === slug);
}

export function findByLegacyPath(path: string): RouteSeo | undefined {
    const normalized = path.replace(/\/+$/, "").toLowerCase();
    return Routes.find((route) =>
        route.legacyPaths?.some(
            (legacy) => legacy.replace(/\/+$/, "").toLowerCase() === normalized
        )
    );
}

/** Routes that have enough data to render a full landing page. */
export function landingRoutes(): RouteSeo[] {
    return Routes.filter((route) => route.operation !== undefined && route.h1 !== undefined);
}

/** Absolute canonical URL for a slug, e.g. https://math-pages.com/multiplication-worksheets */
export function canonicalUrl(slug: string): string {
    if (slug === "/") {
        return SITE_ORIGIN;
    }
    return SITE_ORIGIN + slug;
}
